import React, { useEffect, useState } from 'react';
import './Carousel.css';
import { useSelector, useDispatch } from 'react-redux';
import CustomTeamList from '../organization/CustomTeamList';
import { setActiveFrontpage } from '../../store/FrontpageStore';
import * as DeviceStore from '../../store/DeviceStore';
import * as FrontpageStore from '../../store/FrontpageStore';


const Carousel = () => {
    const dispatch = useDispatch();

    const currentIndex = useSelector(state => state[FrontpageStore.reducerName].activeFrontpage);
    const device = useSelector(state => state[DeviceStore.reducerName].device);

    const [currentPadding, setCurrentPadding] = useState(currentIndex);

    // 82-95
    const administrationPage = [
        {
            id: 83, // Driftsbyen Administration
        },
        {
            id: 86, // Park Administration
        },
        {
            id: 93, // Vej Administration
        },
        {
            id: 95, // Værksted
        },
        {
            id: 90, // Teknik
        },
    ];

    const parkPage = [
        {
            id: 87, // Park By
            width: 25
        },
        {
            id: 88, // Park Land
            width: 35
        },
        {
            id: 89, // Skole/inst
            width: 40
        },
    ];

    const vejPage = [
        {
            id: 83, // Driftsbyen Administration
        },
        {
            id: 86, // Park Administration
        },
        {
            id: 93, // Vej Administration

        },
        {
            id: 92, // Vejvæsnet

        },
        {
            id: 94, // VejService
        },
        {
            id: 95, // Værksted
        },
    ];

    // const vandKloakTeknikPage = [
    //     {
    //         id: 95, // Værksted
    //         width: 16.5
    //     },
    //     {
    //         id: 90, // Teknik
    //         width: 16.667
    //     },
    //     {
    //         id: 84, // HTK Forsyning Ledelse
    //         width: 16.667

    //     },
    //     {
    //         id: 82, // HTK Forsyning Økonmi, kunder og affald
    //         width: 16.667,  
    //         className: 'subteams-økonomi-kunder-affald',
    //         subteams: [211]
    //     },
    //     {            
    //         id: 210, // HTK Forsyning Økonmi, kunder og affald (Kundercenter)
    //         width: 16.667,  
    //         className: 'subteams-økonomi-kunder-affald'
    //     },
    //     {
    //         id: 91, // HTK Forsyning vand
    //         width: 16.667

    //     },
    //     {
    //         id: 85, // HTK Forsyning Spildvand
    //         width: 16.667
    //     },
    // ];

    const forsyningPage = [
        {
            id: 84, // HTK Forsyning Ledelse
            width: 18
        },
        {
            id: 82, // HTK Forsyning Økonmi, kunder og affald
            width: 27,  
            className: 'subteams-økonomi-kunder-affald',
            subteams: [211]
        },
        {            
            id: 210, // HTK Forsyning Økonmi, kunder og affald (Kundercenter)
            width: 27,  
            className: 'subteams-økonomi-kunder-affald'
        },
        {
            id: 212, // Plan og projekter
            width: 18

        },
        {
            id: 91, // HTK Forsyning vand
            width: 18

        },
        {
            id: 85, // HTK Forsyning Spildvand
            width: 18

        },
    ];

    const contentCode = device.contentCode;

    const children = [];

    switch(contentCode){
        case 'administration':
            children.length = 0;
            children.push(<CustomTeamList key={1} padding={currentPadding} teams={administrationPage}/>);
            children.push(<CustomTeamList key={2} padding={currentPadding} teams={parkPage}/>);
            children.push(<CustomTeamList key={3} padding={currentPadding} teams={vejPage}/>);
            children.push(<CustomTeamList key={4} padding={currentPadding} teams={forsyningPage}/>);
            break;
        case 'park':
            children.length = 0;
            children.push(<CustomTeamList key={1} padding={currentPadding} teams={parkPage}/>);
            children.push(<CustomTeamList key={2} padding={currentPadding} teams={vejPage}/>);
            children.push(<CustomTeamList key={3} padding={currentPadding} teams={forsyningPage}/>);
            children.push(<CustomTeamList key={4} padding={currentPadding} teams={administrationPage}/>);
            break;
        case 'vej':
            children.length = 0;
            children.push(<CustomTeamList key={1} padding={currentPadding} teams={vejPage}/>);
            children.push(<CustomTeamList key={2} padding={currentPadding} teams={forsyningPage}/>);
            children.push(<CustomTeamList key={3} padding={currentPadding} teams={administrationPage}/>);
            children.push(<CustomTeamList key={4} padding={currentPadding} teams={parkPage}/>);
            break;
        case 'forsyning':
            children.length = 0;
            children.push(<CustomTeamList key={1} padding={currentPadding} teams={forsyningPage}/>);
            children.push(<CustomTeamList key={2} padding={currentPadding} teams={administrationPage}/>);
            children.push(<CustomTeamList key={3} padding={currentPadding} teams={parkPage}/>);
            children.push(<CustomTeamList key={4} padding={currentPadding} teams={vejPage}/>);
            break;
    }
   
    const [length, setLength] = useState(children.length);

    // Set the length to match current children from props
    useEffect(() => {
        setLength(children.length)
    }, [children]);

    const next = () => {
        if (currentIndex < (length - 1)) {
            dispatch(setActiveFrontpage(1));
            setCurrentPadding(prevState => prevState + 5);
        }
    }
    
    const prev = () => {
        if (currentIndex > 0) {
            dispatch(setActiveFrontpage(-1));
            setCurrentPadding(prevState => prevState - 5);
        }
    }

    const [touchPosition, setTouchPosition] = useState(null);

    const handleTouchStart = (e) => {
        const touchDown = e.touches[0].clientX;
        setTouchPosition(touchDown);
    }

    const handleTouchMove = (e) => {
        const touchDown = touchPosition
    
        if(touchDown === null) {
            return
        }
    
        const currentTouch = e.touches[0].clientX
        const diff = touchDown - currentTouch
    
        if (diff > 5) {
            next();
        }
    
        if (diff < -5) {
            prev();
        }
    
        setTouchPosition(null)
    }

    let hideLeftArrow = currentIndex == 0 ? 'hidden' : 'visible'; // hvis den står på den første
    let hideRightArrow = currentIndex == length - 1 ? 'hidden' : 'visible'; // hvis den står på det sidste child

    return (
      
        <div className='carousel-container'>
            <div className='carousel-wrapper'>

                    <div className="left-arrow" onClick={prev} style={{visibility: hideLeftArrow}}>
                        &#8249;
                    </div>

                    <div className='carousel-content-wrapper' onTouchStart={handleTouchStart} onTouchMove={handleTouchMove}>
                        <div className="carousel-content" style={{ transform: `translateX(-${currentIndex * 100}%)` }}>
                            {children}
                        </div>
                    </div>

                    <div className="right-arrow" onClick={next} style={{visibility: hideRightArrow}}>
                        &#8250;
                    </div>
            </div>
        </div>
    )

}

export default Carousel;